import { useParams } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { useApplicationContext } from '@css-xp/base/common-context';
import { usePartnerAccountDomains } from './use-partner-account-domains';

export const useGetRelatedDomainsForCurrentTxA = () => {
  const context = useApplicationContext();
  const { txaId } = useParams<{ txaId: string }>();
  const selectedPartnerAccountData = context.partnerAccounts.find(
    ({ transactionAccountId }: { transactionAccountId: string }) => transactionAccountId === txaId
  );

  const partnerDomainsInfo = usePartnerAccountDomains(
    isEmpty(selectedPartnerAccountData) ? { id: '' } : selectedPartnerAccountData
  );
  return {
    relatedDomains: partnerDomainsInfo.data?.relatedDomains ?? [],
    isLoading: partnerDomainsInfo.isLoading,
    error: partnerDomainsInfo.error,
  };
};
